import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { SparklesIcon, DownloadIcon, ArrowRightIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function ThankYouPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const downloads = [{
    title: 'Recetas Antiinflamatorias',
    desc: 'Libro Principal (PDF)',
    type: 'main'
  }, {
    title: 'Batidos Saludables',
    desc: 'Bonus Exclusivo (PDF)',
    type: 'bonus'
  }, {
    title: 'Lista de Compras Premium',
    desc: 'Bonus Exclusivo (PDF)',
    type: 'bonus'
  }, {
    title: 'Planificador Semanal',
    desc: 'Bonus Exclusivo (PDF)',
    type: 'bonus'
  }, {
    title: 'Postres Sin Azúcar',
    desc: 'Oferta Especial (PDF)',
    type: 'upsell'
  }, {
    title: 'Recetas Saludables Vol. 2',
    desc: 'Oferta Especial (PDF)',
    type: 'upsell'
  }];
  return <div className="min-h-screen bg-wellness-cream flex flex-col" data-id="element-234">
      <div className="flex-grow py-16 px-4" data-id="element-235">
        <div className="max-w-4xl mx-auto" data-id="element-236">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center mb-16" data-id="element-237">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-wellness-light/20 rounded-full mb-6" data-id="element-238">
              <SparklesIcon className="w-10 h-10 text-wellness-primary" data-id="element-239" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-wellness-dark" data-id="element-240">
              ¡Felicidades! Tu Programa Está Listo
            </h1>
            <p className="text-xl text-wellness-body max-w-2xl mx-auto" data-id="element-241">
              Gracias por confiar en nosotros. Tu compra ha sido procesada con
              éxito. Aquí tienes acceso inmediato a todo tu material.
            </p>
          </motion.div>

          {/* Downloads Grid */}
          <div className="bg-white rounded-3xl shadow-xl p-8 md:p-12 mb-12 border border-wellness-darkBeige" data-id="element-242">
            <h2 className="text-2xl font-bold mb-8 text-center border-b border-gray-100 pb-4" data-id="element-243">
              Tus Enlaces de Descarga
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-244">
              {downloads.map((item, i) => <motion.div key={i} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: i * 0.1
            }} className={`p-6 rounded-2xl border flex items-center justify-between group hover:shadow-md transition-all cursor-pointer
                    ${item.type === 'main' ? 'bg-wellness-primary/5 border-wellness-primary/20' : item.type === 'bonus' ? 'bg-wellness-beige border-wellness-darkBeige' : 'bg-white border-gray-200'}
                  `} data-id="element-245">
                  <div data-id="element-246">
                    <h3 className="font-bold text-lg text-wellness-dark mb-1" data-id="element-247">
                      {item.title}
                    </h3>
                    <p className="text-sm text-wellness-body" data-id="element-248">{item.desc}</p>
                  </div>
                  <div className="w-12 h-12 rounded-full bg-wellness-primary text-white flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform shadow-sm" data-id="element-249">
                    <DownloadIcon className="w-5 h-5" data-id="element-250" />
                  </div>
                </motion.div>)}
            </div>
          </div>

          {/* Motivational Message */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.8
        }} className="text-center bg-wellness-beige p-10 rounded-3xl mb-12" data-id="element-251">
            <h3 className="text-2xl font-bold mb-4 font-heading italic text-wellness-dark" data-id="element-252">
              "Tu viaje hacia una vida sin inflamación comienza hoy..."
            </h3>
            <p className="text-wellness-body text-lg max-w-2xl mx-auto" data-id="element-253">
              Estamos muy emocionados por ti. Tómate tu tiempo para leer el
              material, planifica tu primera compra y empieza a disfrutar del
              proceso. Recuerda que la constancia es la clave del éxito.
            </p>
          </motion.div>

          {/* Future Offers CTA */}
          <div className="text-center" data-id="element-254">
            <button className="inline-flex items-center space-x-2 text-wellness-primary font-bold hover:text-wellness-dark transition-colors" data-id="element-255">
              <span data-id="element-256">Descubre Más Programas de Bienestar</span>
              <ArrowRightIcon className="w-5 h-5" data-id="element-257" />
            </button>
          </div>
        </div>
      </div>

      <Footer data-id="element-258" />
    </div>;
}